import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "login-right" }
const _hoisted_3 = { class: "login-right-content" }
const _hoisted_4 = { class: "form-floating-custom" }
const _hoisted_5 = { class: "form-floating-custom" }
const _hoisted_6 = { class: "btn-container" }
const _hoisted_7 = {
  key: 0,
  type: "submit",
  class: "btn-login-main"
}
const _hoisted_8 = {
  key: 1,
  class: "btn-login-main",
  type: "button",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "login-left" }, [
      _createElementVNode("h1", { class: "main-title" }, "Reset Your Password"),
      _createElementVNode("p", { class: "main-subtitle" }, "Choose a strong, secure password to protect your account")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "login-header-text" }, [
          _createElementVNode("h2", null, "Create New Password"),
          _createElementVNode("p", null, "Please enter your new security credentials")
        ], -1)),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onRecoverPassword && _ctx.onRecoverPassword(...args))),
          class: "w-100"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-lock input-icon" }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              name: "password",
              id: "newPassword",
              placeholder: " ",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password) = $event)),
              required: "",
              autocomplete: "new-password"
            }, null, 512), [
              [_vModelText, _ctx.form.password]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "newPassword" }, "New Password", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-check-circle input-icon" }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              name: "confirmPassword",
              id: "confirmPassword",
              placeholder: " ",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
              required: "",
              autocomplete: "new-password"
            }, null, 512), [
              [_vModelText, _ctx.form.confirmPassword]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "confirmPassword" }, "Confirm Password", -1))
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "hidden",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.recoveryKey) = $event))
          }, null, 512), [
            [_vModelText, _ctx.form.recoveryKey]
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.isRecoverPasswordLoader)
              ? (_openBlock(), _createElementBlock("button", _hoisted_7, "Reset Password"))
              : (_openBlock(), _createElementBlock("button", _hoisted_8, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("span", {
                    class: "spinner-border spinner-border-sm me-2",
                    role: "status",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createTextVNode(" Updating... ", -1)
                ]))])),
            _createElementVNode("button", {
              class: "btn-back-login",
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/login')))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1),
              _createTextVNode("Back to Login ", -1)
            ]))])
          ])
        ], 32)
      ])
    ])
  ]))
}